export const RUN_GENESIS = 'SAGA/GENESIS'

export const runGenesisSaga = () => ({ type: RUN_GENESIS })
